import { render } from "./multainfraccion.vue?vue&type=template&id=2fc0313c&scoped=true"
import script from "./multainfraccion.vue?vue&type=script&lang=js"
export * from "./multainfraccion.vue?vue&type=script&lang=js"

import "./multainfraccion.vue?vue&type=style&index=0&id=2fc0313c&scoped=true&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fc0313c"]])

export default __exports__